export enum EWorkingDayState {
  NotStarted = 0,
  TaskStarted = 5,
  TaskFinished = 10,
  Finished = 15
}
